<div class="btn btn-{{ severity }} btn-{{ text === undefined ? 'icon-' : '' }}{{ size }}" [class.btn-icon]="text === undefined">
    <app-icon *ngIf="icon" [name]="icon" class="icon-4" />
    <span [ngClass]="truncate ? 'truncate' : 'whitespace-pre text-center'">{{ text ? text : '' }}</span>
</div>
